import {GenricDataModel} from "../../report/modal/genric-data-model";
import {UserModal} from "../../user/modal/user-modal";

export class PartyWiseSalesLedgerModel {
    startDate: Date;
    endDate: Date;
    salesHead: Array<number>;
    status: Array<number>;
    party: number;
}
